import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import {
  ISearchParams,
  SEARCH_LIST_FILTER,
} from '../../../entity-data/entity-data.data';
import { IMasterListHeader } from '../../../entity-master/components/master-list/master-list.interface';
import { IHomeSearchRouteData } from '../../../home-data/home-data.data';
import { Highlight } from '../../../search-data/sub-models/highlight.model';
import { DEFAULT_SEARCH_PARAMS } from '../../../tracked-time-data/tracked-time-data.data';
import { TrackedTimeDataDispatcher } from '../../../tracked-time-data/tracked-time-data.dispatcher';
import { TrackedTimeDataStore } from '../../../tracked-time-data/tracked-time-data.store';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingObject,
  TrackingInputTypeValuesEnum,
} from '../../../tracking/tracking.data';
import { TrackedTimeQuickActionList } from '../../tracked-time-quick-action-list';
import { SearchTrackedTimeListBuilder } from './search-tracked-time-list.builder';
import { NavigationService } from '../../../navigation/navigation.service';
import { map, take } from 'rxjs/operators';
import { FeaturesDataStore } from '../../../features-data/features-data.store';

@Component({
  selector: 'app-search-tracked-time-list',
  templateUrl: 'search-tracked-time-list.component.html',
  styleUrls: ['search-tracked-time-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [SearchTrackedTimeListBuilder],
})
export class SearchTrackedTimeListComponent
  extends TrackedTimeQuickActionList
  implements OnInit {
  relevancySearchMode: boolean;
  lastPageFetched: boolean;
  fetchingList: boolean;
  listFilter: string;
  noItemsDescriptionKey: string;
  defaultSearchParams: ISearchParams;
  sortByHeader: IMasterListHeader;
  headers$: Observable<List<IMasterListHeader>>;
  trackingObject: ITrackingObject;
  trackingScreenName$: Observable<string>;
  highlights$: Observable<List<Highlight>>;

  constructor(
    private _route: ActivatedRoute,
    private _searchTrackedTimeListBuilder: SearchTrackedTimeListBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _navigationService: NavigationService,
    private _featuresDataStore: FeaturesDataStore,
    public trackedTimeDataStore: TrackedTimeDataStore,
    trackedTimeDataDispatcher: TrackedTimeDataDispatcher
  ) {
    super(trackedTimeDataDispatcher);
  }

  ngOnInit() {
    this._featuresDataStore
      .getFeatureToggles()
      .pipe(take(1))
      .subscribe((toggles) => {
        const { inGlobalSearch } = this._route.snapshot
          .data as IHomeSearchRouteData;

        this.listFilter = SEARCH_LIST_FILTER;
        this.defaultSearchParams = DEFAULT_SEARCH_PARAMS;
        this.noItemsDescriptionKey = 'TRACKED_TIME.EMPTY_STATE.SEARCH';
        this.relevancySearchMode = inGlobalSearch;
        this.trackingObject = inGlobalSearch
          ? this._trackingObjectBuilder.buildGlobalSearch()
          : this._trackingObjectBuilder.buildInputList(
              TrackingInputTypeValuesEnum.tracked_time
            );
        this.trackingScreenName$ = this._navigationService.activeRouteName$;
        this.headers$ = this.trackingScreenName$.pipe(
          map((trackingScreenName) =>
            this._searchTrackedTimeListBuilder.buildListHeaders(
              this.trackingObject,
              trackingScreenName,
              this.relevancySearchMode
            )
          )
        );
        this.highlights$ = this.trackedTimeDataStore.getHighlights(
          this.listFilter
        );
      });
  }
}
